export default "__VITE_ASSET__af460111__"